import type { State } from '../types';

export const getAssociatedIssues = (state: State) => state.associatedIssues;
export const getIsInitialized = (state: State) => state.associatedIssues !== undefined;
